import { Button, CircularProgress, Theme } from '@mui/material'
import createStyles from '@mui/styles/createStyles'
import makeStyles from '@mui/styles/makeStyles'
import React from 'react'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    buttonContainer: {
      textAlign: 'right',
    },
    icon: {
      marginRight: theme.spacing(1),
    },
  })
)

interface Props {
  disabled?: boolean
  children?: any
}

export const SubmitButton: React.FC<Props> = ({ disabled = false, children }) => {
  const classes = useStyles()
  return (
    <div className={classes.buttonContainer}>
      <Button variant="outlined" color="primary" type="submit" disabled={disabled}>
        {disabled && <CircularProgress className={classes.icon} size={20} />}
        {children}
      </Button>
    </div>
  )
}
